import { observable, action } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../services/web/agent';

class LoginSettingsStore {
    @observable stepInProgress = false;
    @setter @observable credentialsButton;
    @setter @observable defaultLoginMethod;
    @setter @observable availableAuthMethods;
    @setter @observable macAutoRedirect;
    @observable tenant = '';

    @action toggleLoginCredentials() {
        this.credentialsButton = !this.credentialsButton;
    }

    @action setTenant(value) { this.tenant = value; }

    @action changeDefaultLoginMethod(defaultLoginMethod) {
        this.defaultLoginMethod = defaultLoginMethod;
    }

    @action setLoginSettings() {
        return agent.TenantConfiguration.setLoginSettings(this.credentialsButton, this.defaultLoginMethod, this.availableAuthMethods)
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    }

    @action getLoginSettings() {
        return agent.TenantConfiguration.getLoginSettings()
            .then(action((data) => {
                this.credentialsButton = data.credentialsButton;
                this.defaultLoginMethod = data.defaultLoginMethod?.toUpperCase();
                this.availableAuthMethods = data.availableAuthMethods;
            }));
    }

    //Get the login settings at login page
    @action getDefaultLoginMethod() {
        var defaultLoginMethod = agent.TenantConfiguration.getDefaultLoginMethod(this.tenant)
            .then(action((data) => {
                this.credentialsButton = data.credentialsButton;
                this.defaultLoginMethod = data.defaultLoginMethod?.toUpperCase();
                this.macAutoRedirect = data.macAutoRedirect;
            }));

        window.sessionStorage.setItem('defaultLoginMethod', defaultLoginMethod);

        return defaultLoginMethod;
    }
}

export default new LoginSettingsStore();


// WEBPACK FOOTER //
// ./src/stores/loginSettingsStore.js